export default defineNuxtRouteMiddleware(async () => {
  const client = useClient();
  const localePath = useLocalePath();

  if (client.value) {
    return navigateTo(localePath("/account"), { replace: true });
  }
});
